import * as React from 'react';

import { HistoryContext } from './contexts';

/**
 * Hook to access the low-level history controller.
 */
export function useHistory() {
    const history = React.useContext(HistoryContext);
    if (!history) {
        throw new Error('useHistory must be used within a <Router>');
    }

    return history;
}
